/*
 * neuchief-ux.js
 * Isolated Neuchief UX enhancement layer. Loaded deferred, AFTER global-script,
 * so the theme's PUB/SUB globals (subscribe / publish / PUB_SUB_EVENTS) are available.
 * Every feature is guarded so a missing dependency degrades gracefully.
 */
(function () {
  'use strict';

  var CHECK_SVG =
    '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false" fill="none" ' +
    'stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">' +
    '<path d="M20 6 9 17l-5-5"/></svg>';

  /* ---------------------------------------------------------------------------
   * FEATURE: Add-to-cart success feedback
   *  - Primary: flash an "Added" micro-state on the add-to-cart button(s).
   *  - Fallback: show a toast ONLY when there is no cart drawer to open
   *    (cart type = page), so we never double-confirm.
   * ------------------------------------------------------------------------- */
  function toastRegion() {
    var r = document.getElementById('nc-toast-region');
    if (!r) {
      r = document.createElement('div');
      r.id = 'nc-toast-region';
      r.className = 'nc-toast-region';
      r.setAttribute('aria-live', 'polite');
      r.setAttribute('aria-atomic', 'true');
      document.body.appendChild(r);
    }
    return r;
  }

  function showToast(title, href, linkText) {
    var t = document.createElement('div');
    t.className = 'nc-toast';
    t.setAttribute('role', 'status');
    var html =
      '<span class="nc-toast__icon">' + CHECK_SVG + '</span>' +
      '<span class="nc-toast__body"><span class="nc-toast__title"></span></span>';
    t.innerHTML = html;
    t.querySelector('.nc-toast__title').textContent = title;
    if (href) {
      var a = document.createElement('a');
      a.className = 'nc-toast__link';
      a.href = href;
      a.textContent = linkText || 'View cart';
      t.appendChild(a);
    }
    toastRegion().appendChild(t);
    requestAnimationFrame(function () { t.classList.add('is-visible'); });
    setTimeout(function () {
      t.classList.remove('is-visible');
      setTimeout(function () { t.remove(); }, 400);
    }, 4000);
  }

  function flashAdded(button) {
    if (!button) return;
    button.classList.remove('nc-added');
    // force reflow so the animation can restart on repeat adds
    void button.offsetWidth;
    button.classList.add('nc-added');
    setTimeout(function () { button.classList.remove('nc-added'); }, 1500);
  }

  function initAddToCartFeedback() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (data) {
      if (!data || data.source !== 'product-form-component') return;

      // Flash the button that was actually submitted (main or sticky ATC).
      var btn = (data.submitter && data.submitter.classList) ? data.submitter : null;
      if (btn && btn.classList.contains('add-to-cart-button')) {
        flashAdded(btn);
      } else {
        // Fall back to flashing any add-to-cart button on the page.
        document.querySelectorAll('.add-to-cart-button').forEach(flashAdded);
      }

      // Only toast when there is no cart drawer that will open on its own.
      if (!document.querySelector('cart-drawer')) {
        var cartUrl = (window.routes && window.routes.cart_url) || '/cart';
        showToast('Added to cart', cartUrl, 'View cart');
      }
    });
  }

  /* ---------------------------------------------------------------------------
   * Boot
   * ------------------------------------------------------------------------- */
  function init() {
    initAddToCartFeedback();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
